import styled from "styled-components";

// Format paise to short rupee string (e.g. ₹1.5L, ₹2.3Cr)
export const fmtRupees = (paise) => {
  const r = (paise || 0) / 100;
  if (r >= 10000000) return `₹${(r / 10000000).toFixed(2)}Cr`;
  if (r >= 100000) return `₹${(r / 100000).toFixed(2)}L`;
  if (r >= 1000) return `₹${(r / 1000).toFixed(1)}K`;
  return `₹${r.toLocaleString("en-IN")}`;
};

// Format paise to exact rupees
export const fmtRupeesExact = (paise) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format((paise || 0) / 100);

export const fmtNum = (n) =>
  new Intl.NumberFormat("en-IN").format(n || 0);

export const getDefaultDates = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  return {
    startDate: start.toISOString().split("T")[0],
    endDate: end.toISOString().split("T")[0],
  };
};

// ── Shared Styled Components ──────────────────────────────────────────────

export const PageContainer = styled.div`
  animation: fadeIn 0.3s ease;
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 16px 0;
`;

export const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06);
  border: 1px solid #e2e8f0;
  margin-bottom: 20px;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  &:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,0,0,0.07); }
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const StatValue = styled.div`
  font-size: 26px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.5px;
`;

export const StatSub = styled.div`
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
`;

export const IconBox = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => p.$bg || "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)"};
  margin-bottom: 12px;
  svg { font-size: 20px; color: white; }
`;

export const GRADIENTS = {
  purple: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
  green: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
  amber: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
  pink: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
  blue: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
  teal: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
  red: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
  indigo: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
};

export const CHART_COLORS = {
  gmv: "#6366f1",
  platformFee: "#10b981",
  creatorPayout: "#3b82f6",
  convenienceFee: "#f59e0b",
  transactions: "#ec4899",
  signups: "#6366f1",
  brandPages: "#10b981",
  offerings: "#f59e0b",
};
